/**
 * Stock player-facing blurbs per MainEvent format — the single source of truth
 * for the copy shown on an event. Consumed by:
 *   - the admin create forms (auto-fill the Description field), and
 *   - the NFL card-league seeds (so seeded and admin-created leagues read alike).
 *
 * Dependency-free on purpose (plain strings, no prisma/React imports) so it is
 * safe to import from client components (`@/services/...`) AND from
 * prisma/seed-*.ts scripts under tsx (relative import).
 */

export const FORMAT_DESCRIPTIONS: Record<string, string> = {
  STANDARD:
    "Call every game, every week. Pick the winner of each matchup on the slate — correct picks bank points, and your score builds all season long. No rosters, no draft, just your read on the games. Most points at the end takes it.",
  SURVIVOR:
    "One pick a week. Survive to the next. Choose a single team you think will win — but you can't pick the same team twice all season. Win and you advance; a loss (or a tie) knocks you out. The last entrant standing wins it all.",
  BEST_BALL:
    "Draft your deck, then let it ride. Lock a 10-card roster (QBs, RBs, WRs, TEs, a K) and we auto-start your 8 highest-scoring cards every week — no lineups to set, no waivers, nothing to manage. PPR scoring, points stack all season, highest total wins.",
  DRAFT_PPR:
    "Your roster, your calls, every week. Lock in your card roster, then set your starting lineup each week to chase the best matchups. Full PPR scoring rewards volume — receptions, yards, and TDs all count. Manage it right all season and the top point total wins.",
};

/**
 * Every stock blurb, for "is the field still a default?" checks — lets a form
 * auto-swap the description on format change without ever clobbering copy an
 * admin has customized.
 */
export const STOCK_DESCRIPTIONS: ReadonlySet<string> = new Set(Object.values(FORMAT_DESCRIPTIONS));
